import { render, staticRenderFns } from "./QuemSomos.vue?vue&type=template&id=e3b6895c&scoped=true"
import script from "./QuemSomos.vue?vue&type=script&lang=js"
export * from "./QuemSomos.vue?vue&type=script&lang=js"
import style0 from "./QuemSomos.vue?vue&type=style&index=0&id=e3b6895c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b6895c",
  null
  
)

export default component.exports